import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { PeerToPeerModel } from '../models/peer_to_peer';
import { cloneFilterState } from './data-filter.service';
@Injectable({
  providedIn: 'root'
})
export class Analytics10Service {
  private http = inject(HttpClient);

  getAnalyticsData(transactionType: any, adminId: any, locId: any){
    let params = {};
    if(transactionType!="All")
    params = {
      transactionType:transactionType
    }
    if(adminId != null)
    {
      (params as any)["userID"] = adminId;
      (params as any)["locationGrouping"] = locId;
    }
    return this.http.get(environment.apiUrl+"fetch/analytics",{
      params:params
    }).pipe(map(resp => {
      (resp as any)["docs"] = (resp as any)["docs"].map((product: any)=> PeerToPeerModel.fromJson(product)) ;
      return resp;
    }));
  }

  requestToken(data: any){
    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
    return this.http.get(environment.apiUrl+"request/token",{params:data,headers:headers,responseType: 'text'});
  }

  getAnalyticsPagedData(skip: any, filter: any, adminId: any){
    filter = cloneFilterState(filter || {});
    if(filter['regionId'] == 'All' || !(filter['regionId'])){
      delete filter.regionId;
    }
    if(filter['campusId'] == 'All' || !(filter['campusId'])){
      delete filter.campusId;
    }
    if(filter['facilityId'] == 'All' || !(filter['facilityId'])) {
      delete filter.facilityId;
    }
    if(filter['serviceGroup'] == 'All'){
      delete filter.serviceGroup;
    }
    const filterString = this.generateQueryStringFromObject(filter);
    if (adminId != null) {
      // return this.http.get(
        // environment.apiUrl +
        //   "fetch/analytics?$skip=" +
        //   skip +
        //   "&$limit=10&" +
        //   filterString +
        //   "&adminId=" +
        //   adminId +
        //   "&device=" + 
        return this.http.get(
          environment.apiUrl +
            "fetch/analytics?$skip=" +
            skip +
            "&$limit=10&adminId=" +
            adminId + "&" + filterString)
        } 
    return this.http.get(
      environment.apiUrl +
        "fetch/analytics?$skip=" +
        skip +
        "&$limit=10&" +
        filterString
    );
  }

  fetchFilterOptions(filter: any = null){
    filter = cloneFilterState(filter || {});
    if(filter['regionId'] == 'All'){
      delete filter.regionId;
    }
    if(filter['campusId'] == 'All'){
      delete filter.campusId;
    }
    if(filter['facilityId'] == 'All') {
      delete filter.facilityId;
    }
    if(filter['serviceGroup'] == 'All'){
      delete filter.serviceGroup;
    }
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl+'analytics/filter/options?$'+filterString);
  }

  tryClearWhitespaceFromGlobalSearch(params: any)
  {
    if(params.globalSearch)
    {
      const textToTrim: string = params.globalSearch;
      params.globalSearch = textToTrim.trim();
    }
  }

  generateQueryStringFromObject(params: any){
    params = cloneFilterState(params || {});
    this.tryClearWhitespaceFromGlobalSearch(params);
    return Object.keys(params).map(key => {
      // Properly encode both key and value to handle special characters
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(params[key]);
      return `${encodedKey}=${encodedValue}`;
    }).join('&');
  }

  loadP2PHistory(rowData: any){
    const data = {
    "adminGroupingValue":rowData['adminGroupingValue'],
    "adminId":rowData['adminId'],
    "shiftworked":rowData['shiftworked'],
    "p2pMedId":rowData['p2pMedId'],
    "transactionType":rowData['transactionType'],
    'locationGroupingValue':rowData['locationGroupingValue'],
    "duration":90};
    return this.http.get(environment.apiUrl+"get/p2p/history",{params:data})
  }

  loadShiftSummaries(rowData: any){
    // var qString = this.generateQueryStringFromObject(filterData)
    const data = {"locationGrouping":rowData['locationGroupingValue'],
    "adminGroupingValue":rowData['adminGroupingValue'],
    "adminId":rowData['adminId'],
    "shiftworked":rowData['shiftworked'],
    "p2pMedId":rowData['p2pMedId'],
    "transactionType":rowData['transactionType']}

    return this.http.get(environment.apiUrl + "get/p2p/shifts",{params:data})
  }

  loadShiftTransactions(rowData: any){
    const data = {"locationGrouping":rowData['locationGroupingValue'],
    "adminGroupingValue":rowData['adminGroupingValue'],
    "adminId":rowData['adminId'],
    "shiftworked":rowData['shiftworked'],
    "p2pMedId":rowData['p2pMedId'],
    "transactionType":rowData['transactionType'],
    "shiftDate":rowData['shiftDate']};

    return this.http.get(environment.apiUrl + "get/p2p/shift/transactions",{params:data})
  }

  getWasteRadarData(rowData: any){
      const data = {"duration":90,
                  "locationGroupingValue":rowData['locationGroupingValue'],
                  "adminId":rowData['adminId'],
                  "p2pMedId":rowData['p2pMedId'],
                  "adminGroupingValue":rowData['adminGroupingValue'],
                  'getGroup':rowData['getGroup'],
                  "limitToCommon":rowData['limitToCommon'],
                  'witnessList':rowData['witnessList']
      }
      return this.http.get(environment.apiUrl + "get/p2p/waste/witnesses?",{params:data})
  }

}
